<template>
  <div class="flex items-center input-with-error">
    <with-loader :id="id"
                 :loading="isLoading"
                 class="w-10/12 h-full relative overflow-visible justify-between bg-transparent"
                 use-as-overlay
    >
      <base-input :placeholder="placeholder"
                  ref="inputRef"
                  class="w-full"
                  :variant="inputValue ? 'underlined' : 'underlined-error'"
                  v-model.trim="inputValue"
                  :is-autofocus="true"
                  :disabled="isLoading"
                  @keydown.esc="onEscapeKey"
                  @keydown.enter="handleInputChange"
                  @blur="handleInputBlur"
      />
      <input-error-message :show-error-message="!inputValue"
                           :error-message="errorMessage"
                           class="absolute input-error"
      />
    </with-loader>

    <div v-if="!isLoading"
         class="flex flex-shrink-0 justify-center items-center h-10 w-10 bg-soft rounded-full"
         :class="inputValue ? 'text-success hover:bg-success hover:text-white cursor-pointer' : 'text-gray hover:bg-soft hover:text-gray cursor-not-allowed'"
         @click.prevent.stop="handleInputChange"
         @mouseenter="isSubmitButtonHovered = true"
         @mouseleave="isSubmitButtonHovered = false"
    >
      <vs-icon icon="done" size="1.5rem"/>
    </div>
    <div v-if="showCancelButton"
         class="flex flex-shrink-0 justify-center items-center h-10 w-10 bg-soft text-focus-error hover:bg-focus-error hover:text-white rounded-full cursor-pointer ml-2"
         @mousedown.prevent="onEscapeKey"
    >
      <vs-icon icon="close" size="1.5rem"/>
    </div>
  </div>
</template>

<script>
import WithLoader from '@/components/common/WithLoader'
import InputErrorMessage from '@/components/base-components/InputErrorMessage.vue'

export default {
  name: 'InputWithErrorMessage',

  components: {
    WithLoader,
    InputErrorMessage
  },

  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isNewItem: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Type a name'
    },
    errorMessage: {
      type: String,
      default: 'Name cannot be empty'
    },
    showCancelButton: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isSubmitButtonHovered: false,
      isEscaping: false
    }
  },

  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(inputValue) {
        this.$emit('update:value', inputValue)
      }
    }
  },

  methods: {
    onEscapeKey() {
      this.isEscaping = true
      this.$emit('escape')
    },

    handleInputBlur(e) {
      if (this.isEscaping) {
        this.isEscaping = false
        return
      }
      // prevent saving answer in case of clicking on the cancel button
      if (e.relatedTarget?.id === 'new-item-button') return
      if (this.isLoading) return
      if (this.isSubmitButtonHovered) return

      this.handleInputChange()
    },

    handleInputChange() {
      if (!this.inputValue) {
        this.$refs.inputRef.focus()
        return
      }

      this.$emit('submit', this.inputValue)
    }
  },

  mounted() {
    if (this.isNewItem) this.$refs.inputRef.$el.select()
  }
}
</script>

<style scoped lang="scss">
.input-error {
  top: 35px;
  @apply left-0;
}
</style>

<style>
.input-with-error {
  .con-vs-loading {
    background-color: transparent !important;
  }
}
</style>
